// Extracted from searchFiltersSlice initialState.
// Used for "is this filter active?" checks, "clear all" behavior,
// and filtering default values from URL query params.
export const FILTER_DEFAULTS = {
  basementTypes: [],
  bathrooms: 0,
  bedrooms: 0,
  garageSpaces: 0,
  heatingTypes: [],
  locations: [],
  maxAcres: 99999,
  maxPrice: 10000000,
  maxSquareFootage: 8000,
  minAcres: 0,
  minPrice: 0,
  minSquareFootage: 0,
  mustHaves: [],
  propertyStatus: [],
  propertySubSelectIds: [],
  propertyTypeId: 0,
  sortby: 'Featured Listings',
  status: []
};
